<template>
  <div class="modal-add-supplier">
    <el-dialog class="dialog-form" append-to-body :visible.sync="visibleManufactory" title="Thêm nhà cung cấp" width="600px" :close-on-click-modal="false">
      <el-form ref="manufacoryAddInfo" :model="manufacoryAddInfo" :rules="manufacoryAddInfoRules" label-position="top">
        <el-form-item label="Tên nhà cung cấp" prop="name">
          <el-input v-model="manufacoryAddInfo.name" placeholder="Nhập tên nhà cung cấp" />
        </el-form-item>
        <el-form-item label="Số điện thoại" prop="phoneNo">
          <el-input v-model="manufacoryAddInfo.phoneNo" placeholder="Nhập số điện thoại" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Thuộc nhóm" prop="groups">
              <el-select v-model="manufacoryAddInfo.groups" placeholder="Lựa chọn nhóm" filterable class="width">
                <el-option v-for="(group, index) in groups" :key="index" :label="group.name" :value="group.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Phân loại" prop="person">
              <el-select v-model="manufacoryAddInfo.person" placeholder="Lựa chọn phân loại" filterable class="width">
                <el-option v-for="(type, index) in persons" :key="index" :label="type.label" :value="type.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Email" prop="email">
          <el-input v-model="manufacoryAddInfo.email" placeholder="Nhập email" />
        </el-form-item>
        <el-form-item label="Địa chỉ" prop="address">
          <el-input v-model="manufacoryAddInfo.address" type="textarea" placeholder="Nhập địa chỉ" />
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="text" @click="visibleManufactory = false">Thoát</el-button>
        <el-button type="primary" :loading="btnLoading" @click="btnConfirmAddManu()">Hoàn tất</el-button>
      </template>
    </el-dialog>
    <el-button :type="color" v-if="type === 'button'" @click="handleModal()">
      {{ text }}
    </el-button>
    <div v-else :class="'text-'+color" style="font-weight: bold; cursor: pointer;" @click="handleModal()">
      {{ text }}
    </div>
  </div>
</template>

<script>
import { SupplierServices } from '../../services/nextshop/supplier.service'
import { getMerchanIDCurrent } from '../../utils/auth'
export default {
  props: {
    // text, button
    type: {
      type: String,
      default: "text",
    },
    text: {
      type: String,
      default: "",
    },
    // primary, success, warning, danger
    color: {
      type: String,
      default: "primary",
    },
  },
  data() {
    return {
      btnLoading: false,
      visibleManufactory: false,
      groups: [],
      persons: [
        { value: true, label: "Cá nhân" },
        { value: false, label: "Doanh nghiệp" },
      ],
      manufacoryAddInfo: {
        person: false
      },
      manufacoryAddInfoRules: {
        name: [{ required: true, message: 'Không được để trống' }],
        phoneNo: [
          { message: 'Số điện thoại không đúng', max: 12, trigger: 'blur' },
          { required: true, message: 'Không được để trống'}
        ],
        email: [
          { type: 'email', message: 'Định dạng email không đúng', trigger: 'blur' },
          { required: true, message: 'Không được để trống', trigger: 'change' },
          { min: 6, max: 255, message: 'Chiều dài email từ 6-255 ký tự', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    btnConfirmAddManu() {
      this.$refs.manufacoryAddInfo.validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          const req = {
            ...this.manufacoryAddInfo,
            name: this.manufacoryAddInfo.name.trim(),
            groups: [this.manufacoryAddInfo.groups],
            merchantId: getMerchanIDCurrent(),
            avatarUrl: ''
          }
          await SupplierServices.createrSupplier(req).then(res => {
            this.btnLoading = false
            if (res.success) {
              this.$message.success('Thêm mới nhà cung cấp thành công')
              this.visibleManufactory = false
              this.$refs.manufacoryAddInfo.resetFields()
              this.$emit('response', res.data)
            } else {
              this.$emit('response', {})
            }
          })
        }
      })
    },
    handleModal() {
      this.visibleManufactory = true
      this.getGroupSupp()
    },
    async getGroupSupp() {
      await SupplierServices.getGroupSupplier({
        merchantId: getMerchanIDCurrent()
      }).then(res => {
        if (res.success) {
          this.groups = res.data.map(gr => {
            return {
              ...gr,
              value: gr.id
            }
          })
        }
      })
    },
  }
}
</script>

<style>

</style>